/**
 * Performs an array move (immutable), returning the updated array
 * @param arr The array to move elements in
 * @param from The index element to move from
 * @param to The indexed element to move to
 */
export function move(arr: any[], from: number, to: number): any[] {
  if (!arr || !arr.length) {
    console.error(
      new Error(
        'Attempted to move() an item in an empty array, returning the original to avoid further errors.',
      ),
    );
    return arr;
  }
  if (from < 0 || from > arr.length) {
    console.error(new Error('Attempted to move() an item from outside of the array'));
    return arr;
  }
  if (to < 0 || to > arr.length) {
    console.error(new Error('Attempted to move() an item to outside of the array'));
    return arr;
  }

  const mutated = [...arr];
  mutated.splice(to, 0, mutated.splice(from, 1)[0]);
  return mutated;
}
